import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CommentIcon from "@mui/icons-material/Comment";
import IconButton from "@mui/material/IconButton";
import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { categoryApi, serviceCategoryApi } from "../Component/API/Api";
import { useRef } from "react";
import { Box, Stack } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import "../Component/ServiceList Components/CategoryList.css";

const CategoryListJob = ({
  setJobListData,
  page,
  setFirstLoadIndicator,
  setCategory,
  setSubCategory,
  sourceValueId,
  setSourceValueId,
  source,
  setSource,
}) => {
  const focus = useRef(null);
  const [toggle, setToggle] = useState(true);
  const [categoryHeight, setCategoryHeight] = useState(0);
  const [categoryListData, setCategoryListData] = useState([]);
  const [subCategoryMap, setSubCategoryMap] = useState({});
  const [openCategory, setOpenCategory] = useState(null);

  // Fetch category list on mount
  useEffect(() => {
    fetch(serviceCategoryApi)
      .then((res) => res.json())
      .then((result) => {
        setCategoryListData(result);
      })
      .catch((error) => console.log("ServiceApiError =>", error));
  }, []);

  // Update category height for animation
  useEffect(() => {
    if (focus.current) {
      setCategoryHeight(focus.current.offsetHeight);
    }
  }, [categoryListData, openCategory]);

  // Fetch jobs when page changes
  useEffect(() => {
    if (!sourceValueId) return;

    const formData = new FormData();
    if (source === "subCategory") {
      formData.append("subCategory", sourceValueId);
    } else {
      formData.append("pref", sourceValueId);
    }
    formData.append("page", page);

    const url =
      source === "subCategory"
        ? "https://aps.songjukti.com/profile/login/api_job/job_cate_sub.php"
        : "https://aps.songjukti.com/profile/login/api_job/job_cate.php";

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        setJobListData(result);
      })
      .catch((error) => console.log("ServiceApiError =>", error));
  }, [page, sourceValueId, source]);

  const handleCategoryClick = (cat_id) => {
    setCategory(cat_id);
    setSource("category");
    setSourceValueId(cat_id);

    const formData = new FormData();
    formData.append("pref", cat_id);

    fetch("https://aps.songjukti.com/profile/login/api_job/job_cate.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        setJobListData(result);
      })
      .catch((error) => console.log("ServiceApiError =>", error));
  };

  const handleSubCategoryToggle = async (cat_id) => {
    if (openCategory === cat_id) {
      setOpenCategory(null);
      return;
    }

    // Already loaded
    if (subCategoryMap[cat_id]) {
      setOpenCategory(cat_id);
      return;
    }

    // Fetch only if not already loaded
    try {
      const formData = new FormData();
      formData.append("category_id", cat_id);

      const res = await fetch(
        "https://aps.songjukti.com/profile/login/api_service/all_service_subcategory.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await res.json();

      if (Array.isArray(result) && result.length > 0) {
        setSubCategoryMap((prev) => ({
          ...prev,
          [cat_id]: result,
        }));
        setOpenCategory(cat_id);
      } else {
        setSubCategoryMap((prev) => ({
          ...prev,
          [cat_id]: [],
        }));
        setOpenCategory(cat_id); // still open, just empty
      }
    } catch (error) {
      console.log("SubCategory API Error =>", error);
    }
  };

  const handleSubCategoryClick = (sub_id) => {
    setSubCategory(sub_id);
    setFirstLoadIndicator(false);
    setSource("subCategory");
    setSourceValueId(sub_id);

    const formData = new FormData();
    formData.append("subCategory", sub_id);

    fetch("https://aps.songjukti.com/profile/login/api_job/job_cate_sub.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        setJobListData(result);
      })
      .catch((error) => console.log("ServiceApiError =>", error));
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" sx={{ fontSize: "13pt", fontWeight: 600 }}>
          Categories
        </Typography>
        <IconButton onClick={() => setToggle(!toggle)}>
          <KeyboardArrowDown
            sx={{
              transform: !toggle ? "rotate(-180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          />
        </IconButton>
      </Stack>

      <Box
        sx={{
          height: toggle ? categoryHeight : 0,
          overflow: "hidden",
          transition: "height 0.5s",
        }}
      >
        <List ref={focus}>
          {categoryListData.map((cat) => (
            <React.Fragment key={cat.category_id}>
              <ListItem
                disableGutters
                sx={{ padding: 0, cursor: "pointer" }}
                secondaryAction={
                  <IconButton
                    size="small"
                    onClick={() => handleSubCategoryToggle(cat.category_id)}
                  >
                    <KeyboardArrowDown
                      sx={{
                        transform:
                          openCategory === cat.category_id
                            ? "rotate(-180deg)"
                            : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </IconButton>
                }
              >
                <ListItemText
                  primary={cat.category_name}
                  onClick={() => handleCategoryClick(cat.category_id)}
                />
              </ListItem>

              <Collapse
                in={openCategory === cat.category_id}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {(subCategoryMap[cat.category_id] || []).map((sub) => (
                    <ListItem
                      key={sub.subcategory_id}
                      disableGutters
                      sx={{ padding: 0, cursor: "pointer" }}
                    >
                      <ListItemText
                        primary={sub.subcategory_name}
                        sx={{ paddingLeft: "15px" }}
                        onClick={() =>
                          handleSubCategoryClick(sub.subcategory_id)
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default CategoryListJob;
